// all panels map
// copy group
const informalCopy: Copy = {
  article: {
    onboardingPopup: {
      loggedIn: {
        preTitle:
          '<span class="label-new">Nieuw</span> voor ingelogde gebruikers',
        title: `Vanaf nu kun je artikelen bewaren door op de bladwijzer te tikken.`,
        secondary: `Bewaarde artikelen zijn gemakkelijk terug te vinden onder het tabblad 'Rubrieken'.`,
        buttonClose: `Melding sluiten`,
      },
      loggedOut: {
        preTitle:
          '<span class="label-new">Nieuw</span> voor ingelogde gebruikers',
        title: `Vanaf nu kun je artikelen bewaren door op de bladwijzer te tikken.`,
        secondary: `Bewaarde artikelen zijn gemakkelijk terug te vinden onder het tabblad 'Rubrieken'.`,
        buttonLogin: `Maak een account aan of log in`,
        buttonClose: `Melding sluiten`,
      },
    },
    buttonInfo: {
      PLEASE_LOG_IN: 'Log in om artikelen te bewaren',
      ERROR: 'Technische fout. \nProbeer het later nog eens',
      CLICK_TO_BOOKMARK: 'Klik om het artikel op te slaan',
      CLICK_TO_UNBOOKMARK: 'Klik om het artikel te verwijderen',
    },
  },
  listPage: {
    emptyList: {
      title: `Je hebt nog geen artikelen bewaard.`,
      secondary: `Je kunt artikelen bewaren door bovenaan een artikel op de bladwijzer te tikken.`,
    },
    list: {
      removeButton: `verwijder`,
      removeButtonAlt: `verwijder dit artikel`,
    },
    loggedOutCopy: {
      preTitle: `<span class="label-new">Nieuw</span> voor ingelogde gebruikers`,
      title: `Vanaf nu kun je artikelen bewaren door op de bladwijzer te tikken.`,
      buttonLogin: `Maak een account aan of log in`,
    },
  },
};

const formalCopy: Copy = {
  article: {
    onboardingPopup: {
      loggedIn: {
        preTitle:
          '<span class="label-new">Nieuw</span> voor ingelogde gebruikers',
        title: `Vanaf nu kunt u artikelen bewaren door op de bladwijzer te tikken.`,
        secondary: `Bewaarde artikelen zijn gemakkelijk terug te vinden onder het tabblad 'Rubrieken'.`,
        buttonClose: `Melding sluiten`,
      },
      loggedOut: {
        preTitle:
          '<span class="label-new">Nieuw</span> voor ingelogde gebruikers',
        title: `Vanaf nu kunt u artikelen bewaren door op de bladwijzer te tikken.`,
        secondary: `Bewaarde artikelen zijn gemakkelijk terug te vinden onder het tabblad 'Rubrieken'.`,
        buttonLogin: `Creëer een account of log in`,
        buttonClose: `Melding sluiten`,
      },
    },
    buttonInfo: {
      PLEASE_LOG_IN: 'Log in om artikelen te bewaren',
      ERROR: 'Technische fout. \nProbeer het later nog eens',
      CLICK_TO_BOOKMARK: 'Klik om het artikel op te slaan',
      CLICK_TO_UNBOOKMARK: 'Klik om het artikel te verwijderen',
    },
  },
  listPage: {
    emptyList: {
      title: `U heeft nog geen artikelen bewaard.`,
      secondary: `U kunt artikelen bewaren door bovenaan een artikel op de bladwijzer te tikken.`,
    },
    list: {
      removeButton: `verwijder`,
      removeButtonAlt: `verwijder dit artikel`,
    },
    loggedOutCopy: {
      preTitle: `<span class="label-new">Nieuw</span> voor ingelogde gebruikers`,
      title: `Vanaf nu kunt u artikelen bewaren door op de bladwijzer te tikken.`,
      buttonLogin: `Creëer een account of log in`,
    },
  },
};

export const copyMap: Record<string, Copy> = {
  volkskrant: informalCopy,
  trouw: formalCopy,
  parool: informalCopy,
  demorgen: informalCopy,
  humo: informalCopy,
  margriet: informalCopy,
  libelle: informalCopy,
  flair: informalCopy,
};
